// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"25bb828e","693":"ca1b2a03","845":"d743224e"}[chunkId] + ".chunk.js";
};